import catalogData from '@data/banknotes/catalog.json';
import type { BanknoteCatalog, BanknoteDesign } from '../models/BanknoteTypes';
import type { IBanknoteCatalogRepository } from './IBanknoteCatalogRepository';

const PATTERN_COUNT = 4;

/**
 * Yerel JSON katalog yükleyici.
 */
export class JsonBanknoteCatalogRepository implements IBanknoteCatalogRepository {
  constructor(private readonly rawCatalog: unknown = catalogData) {}

  load(): BanknoteCatalog {
    const catalog = this.rawCatalog as BanknoteCatalog;

    if (!catalog.version || !Array.isArray(catalog.designs) || catalog.designs.length === 0) {
      throw new Error('Invalid banknote catalog: missing version or designs');
    }

    catalog.designs.forEach((design) => this.validateDesign(design));

    return {
      version: catalog.version,
      designs: Object.freeze([...catalog.designs]),
    };
  }

  private validateDesign(design: BanknoteDesign): void {
    if (!design.id || !design.visual || !design.fakeVariants?.length) {
      throw new Error(`Invalid banknote design: ${design.id ?? 'unknown'}`);
    }

    if (design.visual.patternId < 0 || design.visual.patternId >= PATTERN_COUNT) {
      throw new Error(`Invalid patternId for design ${design.id}`);
    }
  }
}
